import Vue from 'vue'
import Router from 'vue-router'

import Auth from '@/components/pages/Auth'
import RegisterUser from '@/components/pages/RegisterUser'
import VerifyEmail from '@/components/pages/VerifyEmail'
import SendResetPassword from '@/components/pages/SendResetPassword'
import ResetPassword from '@/components/pages/ResetPassword'
import Top from '@/components/pages/Top'
import CoopUser from '@/components/pages/CoopUser'
import TeachingHistory from '@/components/pages/TeachingHistory'
import UserInfo from '@/components/pages/UserInfo'
import AccountList from '@/components/pages/AccountList'
import Settlement from '@/components/pages/Settlement'
import Inquiry from '@/components/pages/Inquiry'
import SendReVerifyEmail from '@/components/pages/SendReVerifyEmail'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Top',
      component: Top
    },
    {
      path: '/auth',
      name: 'Auth',
      component: Auth
    },
    {
      path: '/registerUser',
      name: 'RegisterUser',
      component: RegisterUser
    },
    {
      path: '/verifyEmail/:token',
      name: 'VerifyEmail',
      component: VerifyEmail
    },
    {
      path: '/sendResetPassword',
      name: 'SendResetPassword',
      component: SendResetPassword
    },
    {
      path: '/resetPassword/:token',
      name: 'ResetPassword',
      component: ResetPassword
    },
    {
      path: '/coopUser',
      name: 'CoopUser',
      component: CoopUser
    },
    {
      path: '/teachingHistory',
      name: 'TeachingHistory',
      component: TeachingHistory
    },
    {
      path: '/userInfo',
      name: 'UserInfo',
      component: UserInfo
    },
    {
      path: '/accountList',
      name: 'AccountList',
      component: AccountList
    },
    {
      path: '/settlement',
      name: 'Settlement',
      component: Settlement
    },
    {
      path: '/inquiry',
      name: 'Inquiry',
      component: Inquiry
    },
    {
      path: '/sendReVerifyEmail',
      name: 'SendReVerifyEmail',
      component: SendReVerifyEmail
    },
  ]
})